module.exports = __webpack_public_path__ + "w.no1.351488b2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/kanai/female_to_male/w.no1.jpg
// module id = Psr6
// module chunks = 0